<template>
    <b-modal
        id="combined-gradable-moment-modal"
        v-model="modal"
        modal-class="apprentice-default-modal"
        size="lg"
        :title="$t('personal_goals.add_evaluation_moment')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        :ok-title="$t('common.save')"
        ok-variant="primary"
        @shown="onShown"
        @ok="onOk">
        <div class="gradable-moment">
            <b-alert
                v-if="hasError"
                show
                variant="danger">
                {{ $t('personal_goals.not_all_options_correctly_done') }}
            </b-alert>

            <div
                class="personal-goals"
                v-if="personalGoals.length > 0">
                <h4 class="title">{{ $t('common.learning_goals') }}</h4>
                <div
                    class="personal-goal-grade-card"
                    v-for="personalGoal of personalGoals"
                    :key="personalGoal.id">
                    <div class="description">{{ personalGoal.name }}</div>

                    <b-select
                        class="apprentice-primary-select"
                        v-model="personalGoal.grade"
                        :options="gradeSystemOptions">
                    </b-select>
                </div>
            </div>

            <div
                class="skills"
                v-if="vsoSkillTreeIn && vsoSkillTreeIn.skill_skill_trees.length > 0">
                <h4 class="title">{{ $t('personal_goals.skills') }}</h4>
                <div
                    class="skill-grade-card"
                    v-for="skill of skillTree.skill_skill_trees"
                    :key="skill.id">
                    <design-2021-rubric-form-section-component
                        :section-in="skill.rubrics[0].rubric_sections[0]"
                        :key="skill.id"
                        :show-other-results="false"
                        :edit="true"
                        :form-id-in="0"
                        :rubric-show-advanced-options="false"
                        @cell-selected="cellSelected($event, skill.id)"
                        :style="cssVars">
                    </design-2021-rubric-form-section-component>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
import $ from 'jquery';

export default {
    name: 'design-2021-combined-add-gradable-moment-modal-component',
    props: {
        personalGoalsIn: {
            type: Array,
            required: true,
        },
        vsoSkillTreeIn: {
            type: Object,
            required: false,
        },
    },

    data() {
        return {
            modal: false,
            hasError: false,
            personalGoals: [],
            skillTree: this.vsoSkillTreeIn,
            cssCellVariable: 0,
            cssRowVariable: 0,
            cssRubricCellVariable: 0,
            gradeSystemOptions: [
                {
                    value: null,
                    text: 'Kies een beoordeling',
                    disabled: true,
                },
                {
                    value: 'Onvoldoende',
                    text: 'Onvoldoende',
                },
                {
                    value: 'Matig',
                    text: 'Matig',
                },
                {
                    value: 'Voldoende',
                    text: 'Voldoende',
                },
                {
                    value: 'Goed',
                    text: 'Goed',
                },
            ],
            selectedGradeOption: null,
            windowWidth: window.innerWidth,
        };
    },

    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
        });
        this.onResize();
    },

    methods: {
        onOk(bvModalEvent) {
            if (!this.isFormValidated()) {
                bvModalEvent.preventDefault();
                $('#combined-gradable-moment-modal').animate({ scrollTop: 0 }, 500);
                return;
            }

            this.$emit('store-grades', {
                personalGoals: this.personalGoals,
                skillTree: this.skillTree,
            });
        },

        show() {
            this.hasError = false;

            if (this.personalGoalsIn.length > 0) {
                this.personalGoals = this.personalGoalsIn
                    .filter((goal) => goal.archived === 0)
                    .map((goal) => {
                        goal.grade = null;
                        return goal;
                    });
            }

            this.skillTree = { ...this.vsoSkillTreeIn };

            this.skillTree.skill_skill_trees.forEach((skillTree) => {
                skillTree.rubrics[0].rubric_sections[0].rubric_rows.forEach((row) => {
                    row.answers = [];
                });
            });

            this.modal = true;
        },

        cellSelected(newAnswer, skillSkillTreeId) {
            this.skillTree.skill_skill_trees.map((skillSkillTree) => {
                if (skillSkillTree.id === skillSkillTreeId) {
                    const rowIndex = skillSkillTree.rubrics[0].rubric_sections[0].rubric_rows.findIndex(
                        (row) => row.id === newAnswer.row_id,
                    );

                    const currentAnswerForRow =
                        skillSkillTree.rubrics[0].rubric_sections[0].rubric_rows[rowIndex].answers[0];

                    if (!currentAnswerForRow) {
                        skillSkillTree.rubrics[0].rubric_sections[0].rubric_rows[rowIndex].answers.push(newAnswer);
                    } else {
                        skillSkillTree.rubrics[0].rubric_sections[0].rubric_rows.map((row, index) => {
                            if (index === rowIndex) {
                                row.answers = [{ ...newAnswer }];
                            }

                            return row;
                        });
                    }
                }
                return skillSkillTree;
            });

            this.$forceUpdate();
        },

        onShown() {
            const rows = document.querySelectorAll('.rubric-row-heading');
            const cells = document.querySelectorAll('.rubric-cell');
            const RubricCells = document.querySelectorAll('.td-rubric-cell');

            let rowWidth = 145;
            let cellWidth = 0;
            let rubricCellsWidth = 0;

            if (rows.length) {
                rows.forEach((row) => {
                    rowWidth = row.offsetWidth > rowWidth ? Math.round(row.offsetWidth) : rowWidth;
                });
            }

            if (cells.length) {
                cells.forEach((cell) => {
                    cellWidth = cell.offsetWidth > cellWidth ? Math.round(cell.offsetWidth) : cellWidth;
                });
            }

            if (RubricCells.length) {
                RubricCells.forEach((rubricCell) => {
                    rubricCellsWidth =
                        rubricCell.offsetWidth > rubricCellsWidth
                            ? Math.round(rubricCell.offsetWidth)
                            : rubricCellsWidth;
                });
            }

            this.cssCellVariable = cellWidth;
            this.cssRowVariable = rowWidth < 230 ? rowWidth : 230;
            this.cssRubricCellVariable = rowWidth > rubricCellsWidth ? rowWidth : rubricCellsWidth;
        },

        onResize() {
            this.windowWidth = window.innerWidth;
        },

        isFormValidated() {
            let state = true;
            this.hasError = false;

            this.personalGoals.forEach((goal) => {
                if (!goal.grade) {
                    this.hasError = true;
                    state = false;
                }
            });

            this.skillTree.skill_skill_trees.forEach((skillTree) => {
                skillTree.rubrics[0].rubric_sections[0].rubric_rows.forEach((row) => {
                    if (!row.answers.length) {
                        state = false;
                        this.hasError = true;
                    }
                });
            });

            return state;
        },
    },

    computed: {
        cssVars() {
            return {
                '--cell-width': this.cssCellVariable + 'px',
                '--row-width': this.cssRowVariable + 'px',
                '--rubric-cell-width': this.cssRubricCellVariable + 'px',
            };
        },
    },

    watch: {
        skillTree: {
            handler(newVal) {
                this.skillTree = newVal;
            },
            deep: true,
            immediate: true,
        },
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },
};
</script>

<style scoped lang="scss">
.personal-goals {
    position: relative;

    &:has(+ .skills) {
        margin-bottom: 90px;

        &:after {
            content: '';
            display: block;
            position: absolute;
            width: 100%;
            height: 2px;
            background-color: $border-color;
            bottom: -45px;
        }
    }
}

.personal-goal-grade-card,
.skill-grade-card {
    display: flex;

    justify-content: flex-start;
    column-gap: $grid-gutter-width;

    .description {
        font-weight: $font-weight-medium;
        margin-bottom: map-get($grid-gutter-spacing, 'eight');
    }
}

.personal-goal-grade-card {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: $grid-gutter-width;

    select {
        width: 100%;
    }
}

.skill-grade-card {
    align-items: flex-end;
}

.skills {
    overflow-x: auto;

    .title {
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
    }
}

.skill-grade-card {
    .rubric-section {
        margin-bottom: 0;
    }

    ::v-deep .apprentice-rubric-table-grid {
        .rubric-row-heading {
            width: var(--row-width);
        }

        .rubric-cell {
            width: var(--rubric-cell-width);
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    .personal-goal-grade-card {
        flex-direction: row;
        align-items: flex-end;
        column-gap: $grid-gutter-width;
        justify-content: space-between;

        select {
            flex: 0 0 calc(30% - 15px);
        }

        .description {
            margin-bottom: 0;
            flex: 0 0 calc(45% - 15px);

            &:has(+ select) {
                flex: 0 0 calc(70% - 15px);
                align-self: flex-start;
            }
        }

        fieldset {
            flex: 0 0 calc(55% - 15px);
        }
    }

    ::v-deep .apprentice-rubric-table-grid {
        table.table > thead th[role='columnheader'] {
            width: var(--row-width);
        }
    }
}
</style>
